import { hotRank } from "@/mocks/news";

const tagStyle: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-400 text-foreground-950",
  secondary: "bg-secondary-500 text-background-50",
};

export default function HotRank() {
  return (
    <section id="hot" className="scroll-mt-32 mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="mb-8 flex flex-col sm:flex-row sm:items-end justify-between gap-3">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-700">
            <i className="ri-fire-fill text-base" aria-hidden="true"></i>
            LIVE RANKING
          </span>
          <h2 className="font-heading mt-2 text-2xl md:text-3xl font-bold text-foreground-950">
            今日热榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按实时讨论热度排序，每分钟刷新</p>
        </div>
        <button
          type="button"
          className="inline-flex whitespace-nowrap items-center gap-1.5 self-start rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-refresh-line" aria-hidden="true"></i>
          刷新榜单
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {hotRank.map((item) => (
          <a
            key={item.rank}
            href="#live"
            className={`group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 ${
              item.rank <= 2 ? "border-primary-200" : ""
            }`}
          >
            <span
              className={`font-label flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl ${
                item.rank <= 3
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-500"
              }`}
            >
              {String(item.rank).padStart(2, "0")}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className={`whitespace-nowrap rounded px-1.5 py-0.5 text-[10px] font-medium ${tagStyle[item.color]}`}>
                  {item.tag}
                </span>
                <span className="whitespace-nowrap text-[11px] text-foreground-400">{item.category}</span>
              </div>
              <h3 className="mt-1.5 truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                {item.title}
              </h3>
            </div>
            <div className="flex shrink-0 flex-col items-end gap-1">
              <span className="text-xs font-semibold text-primary-600">{item.heat}</span>
              <span className="inline-flex items-center gap-0.5 text-[11px] text-foreground-400">
                {item.delta === "up" && <i className="ri-arrow-up-line text-secondary-600"></i>}
                {item.delta === "down" && <i className="ri-arrow-down-line text-primary-500"></i>}
                {item.delta === "new" && <i className="ri-sparkling-2-line text-accent-600"></i>}
                热度
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}